<template>
    <div>
        <!-- Modo leitura -->
        <div v-if="isReadOnly">
            <v-alert type="info" text class="mb-4">
                As ativações deste acordo já foram cadastradas. Para corrigir,
                cancele o acordo e crie um novo.
            </v-alert>
            <v-data-table
                :headers="headersAtivacao"
                :items="value.ativacoes"
                :items-per-page="10"
                :footer-props="tableConfig"
                class="elevation-0 tabela"
            />
        </div>

        <!-- Modo edição -->
        <div v-else>
            <v-alert
                v-if="!isAcordoExistente"
                type="info"
                text
                class="mb-4"
            >
                As ativações serão salvas junto com o acordo.
            </v-alert>

            <v-row class="mt-2">
                <v-col cols="5" class="py-0">
                    <v-autocomplete
                        label="Ativação"
                        v-model="ativacaoSelecionada"
                        :items="listaAtivacoes"
                        item-text="nome"
                        item-value="id_ativacao"
                        outlined
                        dense
                        class="input-cinza"
                        :loading="carregandoAtivacoes"
                        clearable
                        return-object
                    />
                </v-col>
                <v-col cols="3" class="py-0">
                    <v-text-field
                        label="Quantidade"
                        v-model.number="quantidade"
                        type="number"
                        outlined
                        dense
                        class="input-cinza"
                        min="1"
                    />
                </v-col>
                <v-col cols="4" class="py-0 d-flex">
                    <v-btn
                        color="primary"
                        class="new-button"
                        @click="adicionarAtivacao"
                    >
                        <v-icon left>mdi-plus</v-icon>
                        Adicionar
                    </v-btn>
                    <v-btn
                        color="yellow"
                        dark
                        class="new-button ml-3"
                        @click="abrirImportacao"
                    >
                        <v-icon left>mdi-upload</v-icon>
                        Importar CSV
                    </v-btn>
                </v-col>
            </v-row>

            <v-data-table
                :headers="headersAtivacaoEdit"
                :items="ativacoesPendentes"
                :items-per-page="10"
                :footer-props="tableConfig"
                class="elevation-0 tabela mt-2"
            >
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn icon small @click="removerAtivacao(item)">
                        <v-icon small color="error">mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <v-row no-gutters class="mt-4" v-if="isAcordoExistente">
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    class="new-button"
                    @click="salvarAtivacoes"
                    :disabled="ativacoesPendentes.length === 0"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar Ativações
                </v-btn>
            </v-row>
        </div>

        <!-- Dialog importação CSV -->
        <v-dialog
            content-class="br-15"
            v-model="dialogImportacao"
            width="900"
        >
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title>Importar Ativações (CSV)</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialogImportacao = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-5 pb-0">
                    <div class="instrucoes">
                        <h4>
                            O arquivo CSV deve conter as colunas:
                        </h4>
                        <ul>
                            <li>
                                <strong>ativacao</strong> - Nome da ativação
                                (igual ao cadastro)
                            </li>
                            <li>
                                <strong>quantidade</strong> - Quantidade
                                (número inteiro)
                            </li>
                        </ul>
                        <p class="mt-2 mb-0">
                            Delimitador: <strong>;</strong> (ponto e vírgula)
                        </p>
                    </div>
                    <v-file-input
                        v-model="arquivoCSV"
                        label="Selecione o arquivo CSV"
                        accept=".csv"
                        outlined
                        dense
                        class="input-cinza mt-4"
                        prepend-icon="mdi-file-delimited"
                        :rules="regra.csv"
                    />
                    <v-alert
                        v-if="erroImportacao"
                        type="error"
                        text
                        class="mb-4"
                    >
                        {{ erroMensagem }}
                    </v-alert>
                    <v-expand-transition>
                        <div v-show="errosImportacao.length > 0">
                            <v-data-table
                                :headers="headersErro"
                                :items="errosImportacao"
                                :items-per-page="5"
                                class="elevation-0 tabela"
                            />
                        </div>
                    </v-expand-transition>
                </v-card-text>
                <v-card-actions class="pb-4">
                    <v-btn
                        color="yellow"
                        dark
                        class="new-button ml-2"
                        @click="baixarModelo"
                        :disabled="listaAtivacoes.length === 0"
                    >
                        <v-icon left>mdi-microsoft-excel</v-icon>
                        Baixar modelo
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="new-button mr-2"
                        @click="importarCSV"
                        :disabled="!arquivoCSV"
                        :loading="carregandoImportacao"
                    >
                        <v-icon left>mdi-upload</v-icon>
                        Importar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
export default {
    props: ["value"],
    data() {
        return {
            carregando: false,
            carregandoAtivacoes: false,
            carregandoImportacao: false,
            listaAtivacoes: [],
            ativacaoSelecionada: null,
            quantidade: null,
            ativacoesPendentes: [],
            dialogImportacao: false,
            arquivoCSV: null,
            erroImportacao: false,
            erroMensagem: "",
            errosImportacao: [],
            headersAtivacao: [
                {
                    text: "Ativação",
                    value: "nome_ativacao",
                    align: "center",
                },
                {
                    text: "Quantidade",
                    value: "quantidade",
                    align: "center",
                },
            ],
            headersAtivacaoEdit: [
                {
                    text: "Ativação",
                    value: "nome_ativacao",
                    align: "center",
                },
                {
                    text: "Quantidade",
                    value: "quantidade",
                    align: "center",
                },
                {
                    text: "Ações",
                    value: "actions",
                    align: "center",
                    sortable: false,
                },
            ],
            headersErro: [
                { text: "Linha", value: "linha", align: "center" },
                { text: "Descrição do Erro", value: "msg", align: "left" },
            ],
            tableConfig: {
                "items-per-page-options": [10, 25, 50, -1],
                "items-per-page-text": "Linhas por página",
                "page-text": "{0}-{1} de {2}",
            },
            regra: {
                csv: [
                    (v) => !!v || "Selecione um arquivo.",
                    (v) =>
                        (v &&
                            v.name &&
                            v.name.toLowerCase().endsWith(".csv")) ||
                        "O arquivo deve ser do tipo CSV.",
                ],
            },
        };
    },
    computed: {
        isReadOnly() {
            return (
                (this.value.ativacoes && this.value.ativacoes.length > 0) ||
                this.value.fnLeitura === true
            );
        },
        isAcordoExistente() {
            return this.value.fnEditar === true;
        },
    },
    watch: {
        "value.plano": {
            immediate: true,
            handler(val) {
                if (val === "ANUAL" && this.listaAtivacoes.length === 0) {
                    this.carregarListaAtivacoes();
                }
            },
        },
    },
    methods: {
        async carregarListaAtivacoes() {
            this.carregandoAtivacoes = true;
            try {
                const response = await this.$http().post(
                    "/planejamentoEcommerce/ativacao/lista"
                );
                if (response.data && Array.isArray(response.data)) {
                    this.listaAtivacoes = response.data;
                } else if (response.data && response.data.lista) {
                    this.listaAtivacoes = response.data.lista;
                }
            } catch (e) {
                this.$dialog.notify.error(
                    "Erro ao carregar lista de ativações",
                    { position: "top-right", timeout: 5000 }
                );
            }
            this.carregandoAtivacoes = false;
        },
        adicionarAtivacao() {
            if (!this.ativacaoSelecionada) {
                return this.$dialog.notify.error(
                    "Selecione uma ativação",
                    { position: "top-right", timeout: 5000 }
                );
            }
            if (!this.quantidade || this.quantidade <= 0) {
                return this.$dialog.notify.error(
                    "Informe uma quantidade válida",
                    { position: "top-right", timeout: 5000 }
                );
            }

            const jaExiste = this.ativacoesPendentes.find(
                (a) => a.id_ativacao === this.ativacaoSelecionada.id_ativacao
            );
            if (jaExiste) {
                return this.$dialog.notify.warning(
                    "Esta ativação já foi adicionada",
                    { position: "top-right", timeout: 5000 }
                );
            }

            this.ativacoesPendentes.push({
                id_ativacao: this.ativacaoSelecionada.id_ativacao,
                nome_ativacao: this.ativacaoSelecionada.nome,
                quantidade: this.quantidade,
            });

            this.$emit("input", {
                ...this.value,
                ativacoesPendentes: this.ativacoesPendentes,
            });

            this.ativacaoSelecionada = null;
            this.quantidade = null;
        },
        removerAtivacao(item) {
            const index = this.ativacoesPendentes.indexOf(item);
            if (index > -1) {
                this.ativacoesPendentes.splice(index, 1);
                this.$emit("input", {
                    ...this.value,
                    ativacoesPendentes: this.ativacoesPendentes,
                });
            }
        },
        async salvarAtivacoes() {
            this.carregando = true;
            try {
                const idAcordo = this.value.idAcordos && this.value.idAcordos[0];
                const response = await this.$http().post(
                    "/acordoEcommerce/ativacoes/salvar",
                    {
                        data: {
                            id_acordo: idAcordo,
                            ativacoes: this.ativacoesPendentes.map((a) => ({
                                id_ativacao: a.id_ativacao,
                                quantidade: a.quantidade,
                            })),
                        },
                    }
                );

                if (response.data.sucesso) {
                    this.$dialog.notify.success(
                        response.data.msg || "Ativações salvas com sucesso",
                        { position: "top-right", timeout: 5000 }
                    );
                    this.$emit("input", {
                        ...this.value,
                        ativacoes: response.data.ativacoes,
                    });
                    this.ativacoesPendentes = [];
                } else {
                    this.$dialog.notify.error(
                        response.data.msg || "Erro ao salvar ativações",
                        { position: "top-right", timeout: 5000 }
                    );
                }
            } catch (e) {
                this.$dialog.notify.error("Erro ao salvar ativações", {
                    position: "top-right",
                    timeout: 5000,
                });
            }
            this.carregando = false;
        },
        abrirImportacao() {
            this.arquivoCSV = null;
            this.erroImportacao = false;
            this.erroMensagem = "";
            this.errosImportacao = [];
            this.dialogImportacao = true;
        },
        getAtivacoesModelo() {
            const ativacoesAtuais = this.ativacoesPendentes.length
                ? this.ativacoesPendentes
                : Array.isArray(this.value.ativacoes)
                  ? this.value.ativacoes
                  : [];

            const quantidadesPorAtivacao = new Map(
                ativacoesAtuais.map((ativacao) => [
                    String(ativacao.id_ativacao),
                    ativacao.quantidade,
                ])
            );

            return this.listaAtivacoes.map((ativacao) => ({
                nome: ativacao.nome,
                quantidade:
                    quantidadesPorAtivacao.get(
                        String(ativacao.id_ativacao)
                    ) ?? "",
            }));
        },
        baixarModelo() {
            let csv = "ativacao;quantidade\n";
            this.getAtivacoesModelo().forEach((ativacao) => {
                csv += `${ativacao.nome};${ativacao.quantidade}\n`;
            });
            this.$helpers.downloadCsv(csv, "acordo_ativacoes.csv", "text/csv");
        },
        async importarCSV() {
            this.erroImportacao = false;
            this.erroMensagem = "";
            this.errosImportacao = [];
            this.carregandoImportacao = true;

            const parseCsv = (file) =>
                new Promise((resolve) => {
                    this.$papa.parse(file, {
                        delimiter: ";",
                        header: true,
                        dynamicTyping: true,
                        skipEmptyLines: true,
                        complete: (results) => resolve(results),
                    });
                });

            try {
                const csv = await parseCsv(this.arquivoCSV);

                if (csv.errors && csv.errors.length) {
                    this.erroImportacao = true;
                    this.erroMensagem =
                        "Erro ao ler o arquivo CSV. Verifique o formato e o delimitador (;).";
                    this.carregandoImportacao = false;
                    return;
                }

                const erros = [];
                const adicionados = [];
                const duplicadas = [];

                csv.data.forEach((row, index) => {
                    const linha = index + 2; // +2: header + 1-based index
                    const nomeArquivo = (
                        row.ativacao ||
                        row["Ativação"] ||
                        row.Ativacao ||
                        ""
                    )
                        .toString()
                        .trim();
                    const quantidade = Number(
                        row.quantidade || row.Quantidade
                    );

                    if (!nomeArquivo) {
                        erros.push({
                            linha,
                            msg: "Coluna 'ativacao' vazia ou ausente.",
                        });
                        return;
                    }

                    const ativacao = this.listaAtivacoes.find(
                        (a) =>
                            a.nome &&
                            a.nome.toLowerCase() === nomeArquivo.toLowerCase()
                    );

                    if (!ativacao) {
                        erros.push({
                            linha,
                            msg: `Ativação '${nomeArquivo}' não encontrada no cadastro.`,
                        });
                        return;
                    }

                    if (!quantidade || quantidade <= 0 || isNaN(quantidade)) {
                        erros.push({
                            linha,
                            msg: `Quantidade inválida (${row.quantidade ?? row.Quantidade ?? ""}).`,
                        });
                        return;
                    }

                    const jaExisteCsv = adicionados.find(
                        (a) => a.id_ativacao === ativacao.id_ativacao
                    );

                    if (jaExisteCsv) {
                        duplicadas.push(ativacao.nome);
                        return;
                    }

                    adicionados.push({
                        id_ativacao: ativacao.id_ativacao,
                        nome_ativacao: ativacao.nome,
                        quantidade: quantidade,
                    });
                });

                if (adicionados.length > 0) {
                    this.ativacoesPendentes = adicionados;
                    this.$emit("input", {
                        ...this.value,
                        ativacoesPendentes: this.ativacoesPendentes,
                    });
                }

                if (erros.length > 0) {
                    this.errosImportacao = erros;
                    this.erroImportacao = true;
                    this.erroMensagem = `${erros.length} linha(s) com erro. ${adicionados.length} ativação(ões) adicionada(s).`;
                } else {
                    this.$dialog.notify.success(
                        `${adicionados.length} ativação(ões) adicionada(s) à lista.`,
                        { position: "top-right", timeout: 5000 }
                    );
                    if (duplicadas.length > 0) {
                        this.$dialog.notify.warning(
                            `${duplicadas.length} duplicata(s) ignorada(s).`,
                            { position: "top-right", timeout: 5000 }
                        );
                    }
                    this.dialogImportacao = false;
                }
            } catch (e) {
                this.erroImportacao = true;
                this.erroMensagem = "Erro ao processar o arquivo CSV.";
            }
            this.carregandoImportacao = false;
        },
        async carregarAtivacoesPadrao() {
            if (this.isReadOnly || !this.value.id_fornecedor) return;

            const ano = this.value.mesInicial
                ? parseInt(this.value.mesInicial.split("-")[0])
                : new Date().getFullYear();

            this.carregando = true;
            try {
                const response = await this.$http().post(
                    "/acordoEcommerce/ativacoes/padrao",
                    {
                        data: {
                            id_fornecedor: this.value.id_fornecedor,
                            id_categoria: this.value.id_categoria,
                            id_device: this.value.id_device,
                            id_espaco: this.value.id_espaco,
                            id_espaco_acordo: this.value.id_espaco_acordo,
                            ano,
                        },
                    }
                );

                if (
                    response.data &&
                    Array.isArray(response.data) &&
                    response.data.length > 0
                ) {
                    this.ativacoesPendentes = response.data;
                    this.$emit("input", {
                        ...this.value,
                        ativacoesPendentes: this.ativacoesPendentes,
                    });
                }
            } catch (e) {
                // auto-seleção é opcional; usuário pode adicionar manualmente
            }
            this.carregando = false;
        },
        getAtivacoesPendentes() {
            return this.ativacoesPendentes;
        },
    },
};
</script>
